const data = {
  skills: [
    {
      _id: 1,
      name: "HTML",
      percent: 90,
      description: [
        "HTML concepts,",
        "tags which are most widely used",
        "Forms, Embedding Multimedia, Vector Graphics",
        "Solid structures",
      ],

      picture: "imgs/skills/html.png",
      hadCertificate: true,
      certificate: "certificate/webDevelopment.pdf",
    },
    {
      _id: 2,
      name: "CSS",
      picture: "imgs/skills/css.png",
      description: [
        "CSS architecture: component-based design, BEM, writing reusable code, etc.",
        "Tons of modern CSS techniques to create stunning designs and effects",
        "Advanced CSS animations with @keyframes, animation and transition,",
        "Advanced responsive design: media queries, mobile-first vs desktop-first, em vs rem units, etc.",
        "Responsive images in HTML and CSS for faster pageloads,",
        "Flexbox layouts,  main concepts, introduction to both flex container and flex item specific properties, advanced positioning techniques applied to a huge real-world project",
        "CSS Grid layouts",
      ],

      percent: 90,
      hadCertificate: true,
      certificate: "certificate/cssSass.pdf",
    },
    {
      _id: 3,
      name: "JavaScript",
      picture: "imgs/skills/js.png",
      description: [
        "JavaScript fundamentals (variables, if/else, operators, boolean logic, functions, arrays, objects, loops, strings)",
        "Modern OOP(Classes, constructors, prototypal inheritance, encapsulation)",
        "Asynchronous JavaScript (Event loop, promises, async/await, AJAX calls and APIs),",
        "Modern ES6+ (arrow functions, destructuring, spread operator, optional chaining (ES2020))",
      ],

      percent: 80,
      hadCertificate: true,
      certificate: "certificate/JavaScript.pdf",
    },
    {
      _id: 4,
      name: "JQUERY",
      picture: "imgs/skills/jquery.png",
      description: [],

      percent: 80,
      hadCertificate: true,
      certificate: "certificate/JavaScript.pdf",
    },
    {
      _id: 5,
      name: "React",
      picture: "imgs/skills/react.png",
      description: [
        "Building content with JSX,",
        "communicating with props,",
        "structuring App with class-based components or functional components,",
        "user events and state to create interactive applications,",
        "React Hooks (useState, useEffect, useContext, useReducer, useRef),",
        "handling user input with forms and events,",
        "making API requests with React",
      ],

      percent: 72,
      hadCertificate: true,
      certificate: "certificate/react.pdf",
    },
    {
      _id: 6,
      name: "Redux",
      picture: "imgs/skills/redux.png",
      description: [
        "Integrating React with Redux,",
        "Async actions with Redux thunk,",
        "Redux Store design, Redux dev tools,",
        "Handling forms with Redux forms,",
        "Middlewares with Redux, Actions and Reducers",
      ],

      percent: 70,
      hadCertificate: true,
      certificate: "certificate/react.pdf",
    },
    {
      _id: 7,
      name: "Sass",
      picture: "imgs/skills/sass.png",
      description: [
        "structure your code using SASS",
        "Sass basic features,",
        "SASS compiler",
        "variables and mixins in order to write more concise and flexible code.",
        "extend, placeholder selectors, functions, imports, partials,",
        "make websites responsive for all screen sizes using some SASS techniques.",
      ],

      percent: 80,
      hadCertificate: true,
      certificate: "certificate/cssSass.pdf",
    },
    {
      _id: 8,
      name: "Bootstrap",
      picture: "imgs/skills/bootstrap.png",
      description: [
        "Bootstrap component",
        "customize Bootstrap",
        "he ins and outs of the new Bootstrap 4 utility classes",
      ],

      percent: 60,
      hadCertificate: false,
    },
    {
      _id: 9,
      name: "NodeJs",
      picture: "imgs/skills/nodejs.png",
      description: [
        "Fundamentals of Node.js, core modules and NPM (Node Package Manager)",
        "Fundamentals of Express (Node.js framework): routing, middleware, sending responses, etc.",
        "RESTful API design and development with advanced features: filtering, sorting, aliasing, pagination",
        "CRUD operations with MongoDB database locally and on the Atlas platform (in the cloud)",
      ],
      percent: 55,
      hadCertificate: false,
    },
    {
      _id: 10,
      name: "MongoDB",
      picture: "imgs/skills/mongodb.png",
      description: [
        "Fundamentals of Mongoose (MongoDB JS driver): Data models, CRUD operations, data validation, and middleware",
        "How to work with data in NoSQL databases",
        "Advanced data modelling: relationships between data, embedding, referencing,",
      ],
      percent: 50,
      hadCertificate: false,
    },
    {
      _id: 11,
      name: "Framer Motion",
      picture: "imgs/skills/framer-motion.png",
      description: [
        "basic properties: animate, gestures, variants, motionValues, Scroll-based animations, Propagation, Orchestration, Dynamic variants",
        "Component animation controls",
        "AnimateSharedLayout, AnimatePresence, LazyMotion",
      ],
      percent: 90,
      hadCertificate: false,
    },
  ],
  services: [
    {
      id: 1,
      icon: "imgs/services/development.png",
      name: "Web Development",
      description: "Interactive Web Applications and Dynamic Websites ",
    },
    {
      id: 2,
      icon: "imgs/services/design.png",
      name: "Web Design",
      description:
        "Simplicity is one of the golden rules of website design. The audience should have an enjoyable",
    },
    {
      id: 3,

      icon: "imgs/services/responsive.png",
      name: "Responsive Design",
      description:
        "Having a responsive layout means that your website fluidly resizes for optimal viewing regardless of the screen size or device.",
    },

    {
      id: 4,

      icon: "imgs/services/deployment.png",
      name: "Deployment",
      description:
        "I prefer Netlify, Vercel for front-end part and Heroku for server side. ",
    },
  ],
  experiences: [
    {
      _id: 1,
      icon: "fas fa-award",
      name: "Years Experience",
      amount: 2,
    },
    {
      _id: 2,
      icon: "fas fa-tasks",
      name: "Completed Projects",
      amount: 40,
    },
    {
      _id: 3,
      icon: "far fa-smile",
      name: "Sutisfied Costumers",
      amount: 30,
    },
    {
      _id: 4,
      icon: "fas fa-th-large",
      name: "Personal Projects",
      amount: 50,
    },
  ],

  projects: [
    {
      _id: 1,
      name: "E commerce website (Fully functional)",
      imageLarge: "imgs/projects/large/E-commerce.png",
      imageSmall: "imgs/projects/small/e-commerce.png",
      category: "React, Nodejs, MongoDB",
      technologies: [
        "HTML",
        "SASS/CSS",
        "REACTJS/REDUX",
        "NODEJS/EXPRESS",
        "MONGODB",
        "AWS",
      ],
      deploy: "Heroku",
      isResponsive: "Yes",
      features: [
        "Register/login",
        "Profile Page",
        "Profile Update/picture",
        "Search Products",
        "Add To Cart",
        "Shipping information",
        "Buy product",
        "Paypal Payment",
        "Order History",
        "Best Seller products based on review",
        "Product Details",
        "Seller Page",
        "Become Seller/Admin",
        "Create Product Upload Image to AWS Bucket",
        "Edit/Delete Product",
        "Orders based on Seller",
        "Access/Edit/Delete All Products",
        "Access/Edit/Delete All Users",
        "Access/Edit/Delete All Orders",
      ],
      note: "To check admin features you can login with (login: admin@gmail.com, password: admin) and to check seller features you can login with (login: seller@gmail.com, password: seller). You can make payment by using fake paypal account (paypal account: sb-ox27p5799218@business.example.com parol: LeZ/ko6v) ",
      githubURL: "https://github.com/Shukhratmamadaliev9797/E-commerce-website",
      projectURL: "https://shukhrat-shopify-app.herokuapp.com",
    },
    {
      _id: 2,
      name: "Blog App (Fully functional) ",
      imageLarge: "imgs/projects/large/blog-app.png",
      imageSmall: "imgs/projects/small/blog.png",

      category: "React, Nodejs",
      technologies: [
        "HTML",
        "SASS/CSS",
        "REACTJS/REDUX",
        "NODEJS/EXPRESS",
        "MONGODB",
        "AWS",
      ],
      features: [
        "Register",
        "Login",
        "Profile Page",
        "Profile Update",
        "the latest News",
        "Filter news",
        "Single News Page",
        "Related news",
        "Comment",
        "Become Writer",
        "Compose News",
        "Delete News",
        "Edit News",
        "Upload Images to AWS Bucket",
        "Become Admin",
        "Access All News",
        "Edit News",
        "Access All Users",
        "Edit Users to become Admin or seller",
        "Delete Users",
        "More...",
      ],
      deploy: "Heroku",
      isResponsive: "No",
      note: "To check admin features you can login with (login: admin@gmail.com, password: admin) and to check writer features you can login with (login: writer@gmail.com, password: writer). ",
      githubURL: "https://github.com/Shukhratmamadaliev9797/blog-app",
      projectURL: "https://shukhrat-blog-app.herokuapp.com",
    },
    {
      _id: 3,
      name: "Youtube app",
      imageLarge: "imgs/projects/large/youtube-app.png",
      imageSmall: "imgs/projects/small/youtube.png",
      category: "React",
      technologies: ["HTML", "SASS", "REACTJS, Redux", "Youtube API"],
      features: [
        "Search",
        "25 results",
        "Video details (title, description, channel name)",
      ],
      deploy: "Netlify",
      isResponsive: "No",
      githubURL: "https://github.com/Shukhratmamadaliev9797/youtube-app",
      projectURL: "https://shukhrat-youtube-app.netlify.app/",
    },
    {
      _id: 4,
      name: "Weather app",
      imageLarge: "imgs/projects/large/weather.jpg",
      imageSmall: "imgs/projects/small/weather.png",
      category: "Pure Javascript",
      technologies: ["HTML", "CSS", "JS", "Open weather API"],
      features: [
        "Search via Zipcode, Name",
        "Weather Info",
        "Background video based on weather",
      ],
      deploy: "Github",
      isResponsive: "Yes",
      note: "Info might not be correct because, Free api was used",
      githubURL: "https://github.com/Shukhratmamadaliev9797/weather.io",
      projectURL: "https://shukhratmamadaliev9797.github.io/weather.io/",
    },
    {
      _id: 5,
      name: "Unsplash Photo app",
      imageLarge: "imgs/projects/large/unsplash-app.png",
      imageSmall: "imgs/projects/small/unsplash.png",
      category: "React",
      technologies: ["HTML", "SASS", "REACTJS", "Unsplash.com API"],
      features: ["Search", "10 results", "download"],
      deploy: "Netlify",
      isResponsive: "No",
      githubURL: "https://github.com/Shukhratmamadaliev9797/unsplash-app",
      projectURL: "https://shukhrat-unsplash-app.netlify.app/",
    },
    {
      _id: 6,
      name: "Chat App",
      imageLarge: "imgs/projects/large/chat_app.JPG",
      imageSmall: "imgs/projects/small/chat.png",
      category: "React",
      technologies: ["HTML", "CSS/SASS", "React", "Chatengine.io"],
      features: [
        "Login",
        "Create chat room",
        "send photos",
        "Delete users from chat room",
      ],
      deploy: "Netlify",
      isResponsive: "Yes",
      note: "I'm working on register feature, So you can check app by login ready accounts. Account 1 (Username: user1, password: user1). Account2 (Username: user2, password: user2)",
      githubURL: "https://github.com/Shukhratmamadaliev9797/chat-app",
      projectURL: "https://shukhrat-chat-app.netlify.app/",
    },
    {
      _id: 7,
      name: "Type and Speak app",
      imageLarge: "imgs/projects/large/type-n-speak.png",
      imageSmall: "imgs/projects/small/type-n-speak.png",
      category: "Pure Javascript",
      technologies: ["HTML", "CSS", "JS", "speechSynthesis"],
      features: ["Unlimited Text", "Different voice", "Voice rate"],
      note: "Some browsers might not support different voice",
      isResponsive: "Yes",
      deploy: "Github",
      githubURL: "https://github.com/Shukhratmamadaliev9797/type-n-speak.io",
      projectURL: "https://shukhratmamadaliev9797.github.io/type-n-speak.io/",
    },
    {
      _id: 8,
      name: "Bankist Home Page",
      imageLarge: "imgs/projects/large/bankist-landing-page.png",
      imageSmall: "imgs/projects/small/bankist-landing.png",
      category: "Design",
      technologies: ["HTML", "CSS", "JS"],
      features: ["Modal", "scroll loading images", "pure JS carousel"],
      isResponsive: "No",
      deploy: "Github",
      githubURL:
        "https://github.com/Shukhratmamadaliev9797/Bankist-landing-page",
      projectURL:
        "https://shukhratmamadaliev9797.github.io/Bankist-landing-page/",
    },
    {
      _id: 9,
      name: "Calculator",
      imageLarge: "imgs/projects/large/calculator.JPG",
      imageSmall: "imgs/projects/small/calculator.png",
      features: ["basic calculation"],
      category: "Pure Javascript",
      technologies: ["HTML", "CSS", "JS"],
      isResponsive: "Yes",
      deploy: "Github",
      githubURL: "https://github.com/Shukhratmamadaliev9797/calculator.io",
      projectURL: "https://shukhratmamadaliev9797.github.io/calculator.io/",
    },
    {
      _id: 10,
      name: "Mapty app",
      imageLarge: "imgs/projects/large/mapty-app.png",
      imageSmall: "imgs/projects/small/mapty.png",
      category: "Pure Javascript",
      technologies: ["HTML", "CSS", "JS", "LEAFLETJS MAP"],
      features: ["Access your location", "Mark running location"],
      isResponsive: "No",
      deploy: "Github",
      note: "if you do not allow location, this project does not work",
      githubURL: "https://github.com/Shukhratmamadaliev9797/mapty-app",
      projectURL: "https://shukhratmamadaliev9797.github.io/mapty-app/",
    },
    {
      _id: 11,
      name: "Dice Game",
      imageLarge: "imgs/projects/large/dice_game.JPG",
      imageSmall: "imgs/projects/small/dice-game.png",
      category: "Pure Javascript",
      technologies: ["HTML", "CSS", "JS"],
      features: ["Two Player", "Start again"],
      isResponsive: "No",
      deploy: "Github",
      githubURL: "https://github.com/Shukhratmamadaliev9797/dice_game-app",
      projectURL: "https://shukhratmamadaliev9797.github.io/dice_game-app/",
    },
    {
      _id: 12,
      name: "Bankist App",
      imageLarge: "imgs/projects/large/bankist_app.JPG",
      imageSmall: "imgs/projects/small/bankist-app.png",
      category: "Pure Javascript",
      technologies: ["HTML", "CSS", "JS"],
      features: [
        "Login",
        "Bank account info",
        "transfer money to existed users",
        "request loan",
        "calculation based on user action",
        "logout in 5mins",
      ],
      isResponsive: "No",
      deploy: "Github",
      note: "there are 4 example users to check project user1: sm, pin: 1111 user2: gj, pin: 2222 user3: stw, pin: 3333 user4: ss, pin: 4444",
      githubURL: "https://github.com/Shukhratmamadaliev9797/bankist-app",
      projectURL: "https://shukhratmamadaliev9797.github.io/bankist-app/",
    },

    {
      _id: 13,
      name: "Travel City",
      imageLarge: "imgs/projects/large/travel-city-landing-page.png",
      imageSmall: "imgs/projects/small/city-travel.png",
      category: "Design",
      technologies: ["HTML", "CSS", "SASS", "NODE"],
      features: ["Animations", "Hover effects", "Modal", "Smooth scrool"],
      isResponsive: "Yes",
      deploy: "Github",
      githubURL:
        "https://github.com/Shukhratmamadaliev9797/travel-city-landing-page",
      projectURL:
        "https://shukhratmamadaliev9797.github.io/travel-city-landing-page/",
    },
    {
      _id: 14,
      name: "Hotel Design",
      imageLarge: "imgs/projects/large/hotel-landing-page.png",
      imageSmall: "imgs/projects/small/hotel.png",
      category: "Design",
      technologies: ["HTML", "CSS", "SASS", "NODE"],
      features: ["Advanced CSS/Sass features", "Grid"],
      isResponsive: "Yes",
      deploy: "Github",
      githubURL: "https://github.com/Shukhratmamadaliev9797/hotel-web-design",
      projectURL: "https://shukhratmamadaliev9797.github.io/hotel-web-design/",
    },
  ],
  menu: [
    {
      _id: 1,
      link: "/",
      icon: "fas fa-home",
      name: "Home",
    },
    {
      _id: 2,
      link: "/about",
      icon: "fas fa-user-tie",
      name: "About",
    },
    {
      _id: 3,
      link: "/skills",
      icon: "fas fa-list-alt",
      name: "Skills",
    },
    {
      _id: 4,
      link: "/services",
      icon: "fas fa-tools",
      name: "Services",
    },
    {
      _id: 5,
      link: "/projects",
      icon: "fas fa-qrcode",
      name: "Projects",
    },
    {
      _id: 6,
      link: "/contact",
      icon: "fas fa-phone-square-alt",
      name: "Contact",
    },
    {
      _id: 7,
      link: "/setting",
      icon: "fas fa-cog",
      name: "Setting",
    },
  ],
};

export default data;
